import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    A11y,
} from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y]);

let swiperInstance = null;
let init = false;

function swiperMode() {
    let smallBreakpoint = window.matchMedia('(min-width: 0px) and (max-width: 991px)');
    let largeBreakpoint = window.matchMedia('(min-width: 992px)');

    if (smallBreakpoint.matches) {
        if (!init) {
            init = true;
            swiperInstance = new Swiper('.swiper-container.disabled-on-desktop', {
                slidesPerView: 1.1,
                spaceBetween: 12,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    400: {
                        slidesPerView: 1.2
                    },
                    577: {
                        slidesPerView: 2
                    },
                }
            });
        }
    } else if (largeBreakpoint.matches) {
        if (init && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
            init = false;
        }
    }
}

window.addEventListener('load', swiperMode);
window.addEventListener('resize', swiperMode);

document.querySelectorAll('.swiperTestimonialsSlider').forEach(function (thisSlider) {
    const container = thisSlider.closest('.swiperTestimonialsBlock');
    const nextButton = container.querySelector('.swiperTestimonialsNext');
    const prevButton = container.querySelector('.swiperTestimonialsPrev');

    const nextButtonMob = container.querySelector('.swiperTestimonialsNextMobile');
    const prevButtonMob = container.querySelector('.swiperTestimonialsPrevMobile');

    const swiper = new Swiper(thisSlider, {
        modules: [Navigation, A11y],
        slidesPerView: 1.001,
        spaceBetween: 48,  
        loop: true,
        centeredSlides: true,      
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: [nextButton, nextButtonMob],
            prevEl: [prevButton, prevButtonMob],
        },
    });
});